'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _RequestState = require('../lib/RequestState');

var RequestState = _interopRequireWildcard(_RequestState);

var _ContactPropertiesActionTypes = require('../actionTypes/ContactPropertiesActionTypes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.Map)({
  requestStatus: RequestState.NOT_REQUESTED,
  properties: (0, _immutable.Map)()
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ContactPropertiesActionTypes.REQUESTED_CONTACT_PROPERTY:
      return state.set('requestStatus', RequestState.REQUESTED);
    case _ContactPropertiesActionTypes.RECEIVED_CONTACT_PROPERTY_SUCCESS:
      return state.merge({
        requestStatus: RequestState.SUCCEEDED,
        properties: state.get('properties').set(payload.name, payload)
      });
    case _ContactPropertiesActionTypes.RECEIVED_CONTACT_PROPERTY_FAILED:
      return state.set('requestStatus', RequestState.FAILED);
    default:
      return state;
  }
};

module.exports = exports['default'];